import CryptoJS from "crypto-js";

const PINATA_GATEWAY = "https://funooni-public.mypinata.cloud/ipfs";

export const convertIpfsToUrl = (ipfsUri) => {
  if (!ipfsUri) return null;

  if (ipfsUri.startsWith("ipfs://")) {
    return ipfsUri.replace(/^ipfs:\/\//, `${PINATA_GATEWAY}/`);
  }

  if (ipfsUri.startsWith("Qm") || ipfsUri.startsWith("bafy")) {
    return `${PINATA_GATEWAY}/${ipfsUri}`;
  }

  return ipfsUri;
};

export const decryptJSON = (encryptedData, key) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, key);
  const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
  if (!decryptedString) throw new Error("Decryption failed");
  return JSON.parse(decryptedString);
};

export const fetchTokenMetadata = async (tokenUri, tokenId, aesKey) => {
  try {
    const url = convertIpfsToUrl(tokenUri);
    const response = await fetch(url);

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();
    let metadata = null;

    if (data && data.encryptedData && aesKey) {
      metadata = decryptJSON(data.encryptedData, aesKey);
    } else {
      metadata = data;
    }

    return metadata;
  } catch (err) {
    console.error(`[TOKEN METADATA] Error for token ${tokenId}:`, err);
    return null;
  }
};
